import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Grid } from 'src/components/HTKit/Grid';
import styles from './styles.scss';

const ProductHero = ({ data }) => {
  const { heroImageUrl, header, subheader } = data;

  return heroImageUrl ? (
    <section
      className={cn('paddingTop-large2', styles.container)}
      style={{ backgroundImage: `url(${heroImageUrl})` }}
    >
      <Grid.Fluid classes={styles.grid}>
        <Grid.Row>
          <Grid.Column sm={4} md={6} mdOffset={1} lg={4} lgOffset={4}>
            <h4 className="text-align-center paddingBottom-small">{header}</h4>
            <p className="p1 text-align-center n700">{subheader}</p>
          </Grid.Column>
        </Grid.Row>
      </Grid.Fluid>
    </section>
  ) : null;
};

ProductHero.propTypes = {
  data: PropTypes.shape({
    heroImageUrl: PropTypes.string,
    header: PropTypes.string,
    subheader: PropTypes.string,
  }),
};

export default memo(ProductHero);
